import * as React from "react";
const SvgVerticalLine = (props) => /* @__PURE__ */ React.createElement("svg", { width: 2, preserveAspectRatio: "none", viewBox: "0 0 2 32", className: "h-line", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 1, y1: 0, x2: 1, y2: 32, stroke: "black", strokeWidth: 2, strokeLinecap: "square" }));
export default SvgVerticalLine;
